import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthResponse, AuthService, UserInfo } from 'src/app/auth/auth.service';
import { PaymentService, ProductDisplay } from 'src/app/payment/payment.service';

@Component({
    selector: 'settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {

  activeSection: string = 'account';
  activeSubs: ProductDisplay[];
  accountUpdated: boolean = false;
  userInfo: UserInfo;
  private readonly destroy$ = new Subject<void>();


  constructor(private paymentService: PaymentService, private route: ActivatedRoute, private authService: AuthService) { }

  async updateUsername() {
    if (this.userInfo.username.length < 2) {
      this.authService.openSnackBar('Username must be longer', 'Ok');
      return;
    }

    const response = await this.authService.updateUsername(this.userInfo.username);
    if (response && response.result) {
      this.accountUpdated = true;
      setTimeout(() => {
        this.accountUpdated = false;

      }, 5000);
      return;
    }

    this.authService.openSnackBar('There was an issue updating profile', 'Ok');
  }

  openCustomerPortal() {
    this.paymentService.openCustomerPortal();
  }

  async requestAccountDeletion() {
    let result: AuthResponse = await this.authService.reAuthUser();

    if (result) {
      let response = await this.authService.accountDeletionRequest();
      if (response && response.result) {
        this.authService.openSnackBar('Please confirm email to continue deletion process', 'Ok');
        this.authService.logout();
      }
    }
  }

  selectSection(event: Event, sectionId: string) {
    event.preventDefault();
    this.activeSection = sectionId;
    this.handleDataLoading(sectionId);
  }

  async handleDataLoading(tab: string) {
    this.activeSection = tab;
    switch (tab) {
      case 'billing':
        this.loadSubInfo();
        break;

      case 'account':

        this.loadUserData();
        break;


      default:
        if (this.activeSection == '') {
          this.activeSection = 'profile'
        }


        break;
    }
  }

  async loadUserData() {
    this.userInfo = await this.authService.getUserData();
  }

  async loadSubInfo() {
    this.activeSubs = await this.paymentService.getCustomerActiveSubscription();
  }

  ngOnInit(): void {
    this.activeSubs = [];
    this.userInfo = new UserInfo();
    this.handleDataLoading(this.activeSection);
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(async params => {
        let tab: string = params['tab'];
        this.activeSection = tab ?? 'account';
        if (tab === 'billing') {
          const s = await this.paymentService.checkForActiveSubscription();
          if (s) {
            this.authService.storeAuthToken(s);
          }
        }
        this.handleDataLoading(tab);
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
